module.exports = __webpack_public_path__ + "img/keder_steingrau_ohneral.9b1d5742.jpg";